import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import './banner.scss';
import useLadyService from '@/services/LadyService';
import { useSelector } from 'react-redux';
import { getUserCurrentCity } from '@/stores/slices/userSlice';

import { useParams } from 'react-router-dom';
import { getDisabledFilters } from '@/stores/slices/filterSlice';

const AdvertBanner = ({ props }) => {
	const { type } = props;
	const { lang } = useLadyService();

	const { city: currentCityURLParam } = useParams();

	const disabled_filters = useSelector(getDisabledFilters);

	const disabled = useMemo(() => {
		return new Set(disabled_filters);
	}, [disabled_filters]);

	const hasAds = useMemo(() => {
		return !disabled.has(type === 'video' ? 'tagVideochat' : 'tagEro');
	}, [disabled_filters, type]);

	const currentCityParam = currentCityURLParam?.split('_')[0];

	const cityCurrent = useSelector(getUserCurrentCity);

	const { t } = useTranslation('translation');

	return (
		<a
			href={
				type === 'video'
					? `/${lang}/${
							hasAds
								? (currentCityParam ?? cityCurrent.slug)
								: 'czechia'
						}/vchat`
					: `/${lang}/${
							hasAds
								? (currentCityParam ?? cityCurrent.slug)
								: 'czechia'
						}/ero`
			}
			className={`banner __container advert-banner ${type} invisible`}
		>
			<p className="td-none banner-head ">
				{type === 'video' ? t('modelsforvideo') : t('erocontent')}
			</p>

			<p className="banner-text td-none ">
				{type === 'video' ? (
					`${t('meetbefore')}!`
				) : (
					<>
						{`${t('modelsshare')} `}

						<strong>{t('picfotosvideos')}</strong>
					</>
				)}
			</p>

			{/* {type === 'video' && (
				<div className="banner-buttons">
					<Button clazz="button-icon button--primary no-user-event">
						<Icon
							size={'xs'}
							spritePath={'call-outline'}
						/>
					</Button>
					<Button clazz="button-icon button--primary no-user-events">
						<Icon
							size={'xs'}
							spritePath={'video'}
						/>
					</Button>
					<Button clazz="button-icon button--primary no-user-events">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="18px"
							height="18px"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
							class="lucide lucide-mic-icon lucide-mic"
						>
							<path d="M12 19v3" />
							<path d="M19 10v2a7 7 0 0 1-14 0v-2" />
							<rect
								x="9"
								y="2"
								width="6"
								height="13"
								rx="3"
							/>
						</svg>
					</Button>
				</div>
			)} */}
		</a>
	);
};
export default AdvertBanner;
